import React, { Component } from "react";
import { Helmet } from "react-helmet";

import Message from "~/Components/Message";

import "./AboutPage.less";

class AboutPage extends Component {
  render() {
    return (
      <div className="about-page-component">
        <Helmet>
          <title>____ of the Day | Dream Chimney</title>
          <link rel="canonical" href={`https://www.dreamchimney.com/oftheday/about`} />
        </Helmet>
        <div className="pageTitle">About</div>
        <div className="aboutPageWrapper">
          <Message centered={false} style={{ color: "#333" }}>
            <div style={{ marginBottom: "20px" }}>
              Welcome to “_____” of the Day, the site which we post links or images of funny or interesting things we find during our day on
              the internet. We might be surfing around looking for something and all of a sudden come across something really funny like a
              animated gif of Dom Deliese or a link to story about Mexican UFO's. What ever it might be, it has a place here on “_____” of
              the Day.
            </div>
            <div>Check back often as others read and comment on your rare Internet find...</div>
            <div>
              Follow our{" "}
              <a rel="noopener noreferrer" href="http://feeds.feedburner.com/DreamChimney____OfTheDay" target="_blank">
                RSS
              </a>{" "}
              for instant access to the latest posts or check our twitter @<a rel="noopener noreferrer" href="https://x.com/DreamChimney" target="_blank">dreamchimney</a> for the latest posts.
            </div>
          </Message>
        </div>
      </div>
    );
  }
}

export default AboutPage;
